import { TcmPresenterForMap } from './tcm_presenter_map'

export default TcmPresenterForMap